import React, { useEffect, useState } from 'react';

type Props = {
    isLoading: boolean;
    additionalStyles?: string;
    additionalStylesForLoaded?: string;
} & ({ elementToShow?: never; children: React.ReactNode } | { elementToShow: unknown; children?: never });

function Loader({ isLoading, elementToShow, additionalStyles = '', additionalStylesForLoaded = '', children }: Props) {
    const [showLoader, setShowLoader] = useState(isLoading);
    const [isFinished, setIsFinished] = useState(!isLoading);

    useEffect(() => {
        if (isLoading) {
            setShowLoader(true);
            setIsFinished(false);
        }
    }, [isLoading]);

    function getContent() {
        if (typeof elementToShow === 'function') {
            return elementToShow();
        }

        return elementToShow;
    }

    if (showLoader) {
        return (
            <div className={isLoading ? '' : 'fade-out'} onAnimationEnd={() => setShowLoader(false)}>
                <div className="loader">
                    <div className={`loader-inner ${additionalStyles}`}>
                        <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className={`${isFinished ? '' : 'fade-in'} ${additionalStylesForLoaded}`}
            onAnimationEnd={() => setIsFinished(true)}
        >
            {children ?? getContent()}
        </div>
    );
}

export default Loader;
